<template>
  <div class="page-title-wrapper">
    <img src="../../assets/img/img_logo_dtt@2x.png" class="page-image" alt="DTT logo"/>
    <h1 class="main-title">{{mainTitle}}</h1>
    <p class="subtitle">{{subtitle}}</p>
  </div>
</template>

<script>
  export default {
    name: "PageTitleTop",
    props: {
      mainTitle: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/_base.variables.scss";

  .page-image {
    width: 150px;
  }

  .main-title {
    font-size: 25px;
    font-weight: bold;
  }

  .subtitle {
    font-size: 15px;
  }

  @media screen and (min-width: $screen-sm) {
    .main-title {
      font-size: 35px;
    }

    .subtitle {
      font-size: 18px;
    }
  }

</style>
